import { CopyToClipWhisper } from '@shared/ui/messages/CopyToClipWhisper';
import { useCards } from '@app/api/cards/useCards';

export default function CopyToClipSensitiveCard({
  cardId,
  sensitiveDataKey,
  classes,
  display = 'XX/XX',
}) {
  const { fetchCardSensitiveData } = useCards();

  async function getSensitiveData() {
    const res = await fetchCardSensitiveData(cardId);
    return res.data[sensitiveDataKey];
  }

  return (
    <CopyToClipWhisper
      display={display}
      fetchValue={getSensitiveData}
      classes={classes}
    />
  );
}
